export const SET_DOORPRIZE_DATA = (state, payload) => {
  console.log('set doorprize data', payload)
  state.gifts = payload
  // state.gifts = payload.data.filter(item => item.typePrize === payload.type)
  // console.log(state.gifts, "< data gifts")
}

export const GET_PERSON_DOORPRIZE = (state, payload) => {
  // console.log("kena di mutate gp p dp")
  state.person = payload
}